import { render } from "./ReferralCouponBindView.vue?vue&type=template&id=5750d4b3&scoped=true"
import script from "./ReferralCouponBindView.vue?vue&type=script&lang=js"
export * from "./ReferralCouponBindView.vue?vue&type=script&lang=js"

import "./ReferralCouponBindView.vue?vue&type=style&index=0&id=5750d4b3&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5750d4b3"]])

export default __exports__